import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';

import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import { useMountEffect, useSettings, Utils } from 'app/main/components';
import { type MiddlewhereFile } from 'app/main/components/files-explorer/FilesUtils';
import TotemFilesAttachmentsList from '../files/TotemFilesAttachmentsList';

interface TotemCommunicationsDialogProps {
	uid: string;
	title: string;
	image?: string;
	text?: string;
}

export default function showTotemCommunicationsDialog(props: TotemCommunicationsDialogProps) {
	return openDialog({
		children: <TotemCommunicationsDialog {...props} />,
		maxWidth: 'md',
		fullWidth: true,
		scroll: 'body'
	});
}

function TotemCommunicationsDialog(props: TotemCommunicationsDialogProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	const [filesList, setFilesList] = React.useState<MiddlewhereFile[]>([]);

	useMountEffect(() => {
		Utils.executeApi.get({
			url: `api/hrm/communications/${props.uid}/attachments`,
			dispatch,
			successHandler: ({ data }) => setFilesList(data.list)
		});
	});

	return (
		<>
			{props.image && <img src={props.image} alt={props.title} className="max-h-200 w-full object-cover" />}
			<DialogTitle>{props.title}</DialogTitle>
			<DialogContent>
				<Grid container spacing={2}>
					<Grid size={12}>
						<Typography variant="body2" dangerouslySetInnerHTML={{ __html: props.text || '' }} />
					</Grid>
					<Grid size={12}>
						<TotemFilesAttachmentsList comsUid={props.uid} filesList={filesList} />
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button size="large" onClick={() => dispatch(closeDialog())}>
					{t('DIALOG_ACTION_CLOSE')}
				</Button>
			</DialogActions>
		</>
	);
}
